<template>
  <div>
    <b-card
      style="width:1000px;margin-left:230px;margin-top:50px"
      header="Cancel Registration"
    >
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row style="margin-left:190px">
          <v-col>
            <v-text-field
              v-model="anumber"
              :rules="serialnumberRules"
              label="Enter Serial Number"
              required
              style="width:500px;"
            ></v-text-field>
            <v-text-field
              :rules="mobilenumberRules"
              v-model="mnumber"
              label="Enter Mobile Number"
              required
              style="width:500px"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-btn class="primary mr-4" @click="handleSubmit" style="color:white"
          >Get Details</v-btn
        >
      </v-form>
    </b-card>

    <b-card v-if="name.length" style="width:1000px;margin-left:230px">
      <div class="col-md-12">
        <fieldset class="border p-2">
          <legend class="w-auto">
            <h4 class="header-title mt-0 mb-1">Customer Info</h4>
          </legend>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group mt-3 mt-sm-0">
                <label for="default" style="color:black">Customer Name</label>
                <input
                  v-model.trim="name"
                  placeholder="Check Cutomer Name"
                  class="form-control"
                  type="text"
                  disabled
                />
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group mt-3 mt-sm-0">
                <label for="default" style="color:black">Account NO</label>
                <input
                  v-model.trim="accountNo"
                  class="form-control"
                  type="number"
                  disabled
                  placeholder="Check Account No"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group mt-3 mt-sm-0">
                <label for="default" style="color:black">Mobile NO</label>
                <input
                  v-model.trim="phoneno"
                  class="form-control"
                  type="number"
                  disabled
                  placeholder="Check Mobile No"
                />
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group mt-3 mt-sm-0">
                <label for="default" style="color:black">Serial No</label>
                <input
                  v-model.trim="serialNo"
                  class="form-control"
                  type="number"
                  disabled
                  placeholder="Check Serial No"
                />
              </div>
            </div>
          </div>
        </fieldset>
      </div>

      <v-btn class="primary mr-4" @click="dialog = true"
        >Cancel Registration</v-btn
      >
    </b-card>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-text>
          <v-container
            style=" background: linear-gradient(225deg, #59065d 0%, #8d0b93 50%, #061d48 100%);color: white"
          >
            Are You Sure Want To Cancel Registration
          </v-container>
        </v-card-text>

        <v-card-actions class="ml-12">
          <v-btn class="ml-12" color="blue darken-1" text @click="close"
            >Cancel</v-btn
          >
          <v-btn class="ml-12" color="warning" text @click="handleSave"
            >confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import vueSelect from "vue-select";
import { extractError } from "../../utils/error";
import { getusercancel, CancelRegistration } from "@/services/updateuserid";

export default {
  components: {
    vueSelect,
  },
  data() {
    return {
      serialnumberRules: [(v) => !!v || "Serial Number is Required"],
      mobilenumberRules: [(v) => !!v || "Mobile Number is required"],
      dialog: false,
      mnumber: "",
      anumber: "",
      phoneno: "",
      accountNo: "",
      opentitycode: "",
      editOpentityCode: "",
      serialNo: "",
      show: false,
      name: "",
      searchBy: [
        {
          label: "Mobile Number",
          value: "MOBILE",
        },
        {
          label: "Account Number",
          value: "ACCOUNT",
        },
      ],
      searchData: "",
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    changeData() {
      if (this.searchData.value == "MOBILE") {
        this.anumber = "";
        this.phoneno = "";
        this.accountNo = "";
        this.serialNo = "";
        this.opentitycode = "";
        this.name = "";
        this.show = false;
      }
      if (this.searchData.value == "ACCOUNT") {
        this.mnumber = "";
        this.phoneno = "";
        this.accountNo = "";
        this.serialNo = "";
        this.opentitycode = "";
        this.name = "";
        this.show = false;
      }
    },
    async handleSubmit() {
      try {
        let payload = {};

        payload.serialNo = "serialNo";
        payload.number = this.anumber;

        payload.mobile = "mobile";
        payload.anumber = this.mnumber;

        const result = await getusercancel(payload);
        this.show = true;
        let data = result.response;
        this.name = data.userProfile.customer_NAME;
        this.opentitycode = data.userProfile.opentity_CODE;
        this.phoneno = data.user.mobile;
        this.accountNo = data.userProfile.account_NO;
        this.serialNo = data.user.serialNo;
      } catch (err) {
        this.show = false;
        const message = extractError(err);
        this.$showError(message);
      }
    },

    async handleSave() {
      try {
        let payload = {
          serialNo: this.serialNo,
          mobileNo: this.phoneno,
          //   accNo: this.accountNo,
          //   openCode: {
          //     OpentityCode: this.editOpentityCode,
          //   },
        };
        const result = await CancelRegistration(payload);
        let updatedData = result.response.result;
        // this.opentitycode = updatedData.opentity_CODE;
        this.dialog = false;
        this.resetForm();
        this.$toasted.success("Cancel Registration is Done successfully!", {
          duration: 2000,
        });
      } catch (err) {
        const message = extractError(err);
        this.$showError(message);
      }
    },
    close() {
      this.dialog = false;
    },
    resetForm() {
      this.anumber = "";
      this.mnumber = "";
      this.name = "";
      this.accountNo = "";
      this.phoneno = "";
      this.serialNo = "";
    },
  },
};
</script>
<style scoped>
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  background: linear-gradient(225deg, #59065d 0%, #8d0b93 50%, #061d48 100%);
  color: white;
}
/* .forum{
    margin-left:3 rem !important;
} */
.v-application .ml-12 {
  margin-left: 1.7cm !important;
}
.v-dialog > .v-card > .v-card__text {
  padding: 0 0px 0px;
}
</style>
